export default {
  data() {
    return {
      defaultLabelWidth:100, //默认表单域标签的宽度,所有的 FormItem 都会继承 Form 组件的 label-width 的值
      wrapperWidth:'80%', //自定义wrapper的宽度
    }
  },
  created() {
    this.create();
  },
  methods: {
    create(){
      //通过路由获取的参数
      let queryParam = this.$route.query;
      let param = '';
      for(let key in queryParam) {
        if(key === "queryParam") {
          continue;
        }
        if(param) {
          param += "&";
        }
        param += key+"="+this.$route.query[key];
      }
      this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/detail?"+param).then(res => {
        if(res.code === 200) {
          let data = res.data;
          let entity = data.entity;
          for(let key in this.paasFormData) {
            if((key in entity)) {
              if(entity[key] !== null && entity[key] !== 'null' && typeof entity[key] !== "undefined") {
                if(entity[this.currentIdFiledName]){
                  this.paasFormData[key] = entity[key];
                }else{
                  if(this.defaultEnumKey.indexOf(key) ===-1){
                    this.paasFormData[key] = entity[key];
                  }
                }
              }
            }
          }
          this.createdCallback(data);
        }
      }).catch((error)=>{
        this.$Message.error('数据加载失败，请重试！');
      });
    },
    createdCallback(data) {

    },
    /**
     * 点击关闭逻辑，一般默认跳转list路由页面
     * @param event
     * @param url
     */
    paasPageBack(event, url){
      if(!url) {
        url = this.serviceUrl+"/list";
      }
      this.$router.push({'path': this.setUrlFuncId(url)});
    },
    /**
     * url添加功能ID参数,封装这个方法是以防功能配置也有传参数
     * @param url
     * @returns {*}
     */
    setUrlFuncId(url) {
      if(url.indexOf("?") !== -1) {
        url += '&';
      } else {
        url += '?';
      }
      //组装paasCurrentFunctionId=***
      url += this.$store.state.funcIdName+'='+this.$route.query[this.$store.state.funcIdName];
      return url;
    }
  }
}
